export type UnreadTier = "low" | "mid" | "high";

/**
 * Escala de urgência por quantidade de não-lidas — compartilhada entre o badge
 * do Chat Interno (sidebar) e o contador de não-lidas das conversas do chat,
 * pra a linguagem de cor ser consistente. <10 = calmo · 10–19 = atenção ·
 * 20+ = alerta. Cada componente mapeia o tier pras suas próprias cores
 * (a sidebar usa tons tingidos no navy; a lista usa preenchimento sólido).
 */
export function unreadTier(n: number): UnreadTier {
  if (n >= 20) return "high";
  if (n >= 10) return "mid";
  return "low";
}
